import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsEditHeader.styles'
import ReportsPageHeader from 'modules/reports/components/Page/Header'
import ReportsSchedulePopover from 'modules/reports/popovers/Schedule'
import {Button} from '@material-ui/core'

type Props = {}

function ReportsEditHeader(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'EditHeader')

  function handleTitleChange(title: string) {
    console.log(`title changed to ${title}`)
  }

  function handleRun() {
    console.log('run')
  }

  function handleSave() {
    console.log('save')
  }

  function handleDuplicate() {
    console.log('duplicate')
  }

  const actionButtonProps: any = {variant: 'outlined', size: 'small'}

  return (
    <ReportsPageHeader
      className={classes.root}
      title="New report"
      onTitleChange={handleTitleChange}
    >
      <ReportsSchedulePopover
        trigger={({open, opened, ariaProps}) => {
          return (
            <Button
              onClick={open}
              variant={opened ? 'contained' : undefined}
              color={opened ? 'primary' : undefined}
              aria-label={pt('button-text')}
              {...ariaProps}
              data-testid={p('trigger')}
              {...actionButtonProps}
            >
              {pt('schedule')}
            </Button>
          )
        }}
      />

      <Button onClick={handleRun} {...actionButtonProps}>
        {pt('run')}
      </Button>

      <Button onClick={handleSave} {...actionButtonProps}>
        {pt('save')}
      </Button>

      <Button onClick={handleDuplicate} {...actionButtonProps}>
        {pt('duplicate')}
      </Button>

      <Button href="/reports" {...actionButtonProps}>
        {pt('close')}
      </Button>
    </ReportsPageHeader>
  )
}

export default ReportsEditHeader
